import { gql } from "@apollo/client";

export const SET_ANSWER = gql`
  mutation answer_quiz($quiz_id: Int!, $problem: Int!, $options: [Int]!) {
    answer_quiz(
      quiz_id: $quiz_id
      problem_id: $problem
      options_id: $options
    ) {
      id
    }
  }
`;
